import { KomboIntegrationListDTO } from 'probonio-shared-ui/api';
import { apis, useTenantQuery } from 'probonio-shared-ui/module/api';

export function useKomboIntegrationsList(options?: Parameters<typeof useTenantQuery<KomboIntegrationListDTO>>[2]) {
  return useTenantQuery<KomboIntegrationListDTO>(
    ['integrations', 'kombo', apis.kombo.listIntegrations.name],
    tenantId => apis.kombo.listIntegrations({ tenantId, integrationType: 'HRIS' }).then(res => res.data),
    options,
  );
}

export function useKomboIntegrationStatus(integrationId: string) {
  return useTenantQuery(['integrations', 'kombo', integrationId, apis.kombo.getIntegrationStatus.name], tenantId =>
    apis.kombo.getIntegrationStatus({ tenantId, integrationId }).then(res => res.data),
  );
}
